import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { cn } from '@/utils/cn'
import { useUIStore } from '@/stores/ui.store'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import Workspace from './workspace/Workspace'
import { NotificationList } from '@/components/ui/NotificationList'
import { EmailDogrulamaBanner } from '@/components/ui/EmailDogrulamaBanner'
import { useGlobalKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts'
import { useIdleLogout } from '@/hooks/useIdleLogout'

// Masaüstü (Tauri) → sekmeli (MDI) çalışma alanı; web → klasik tek Outlet.
const isTauri = typeof window !== 'undefined' && !!(window as { __TAURI__?: unknown }).__TAURI__

export function AppLayout() {
  const { sidebarCollapsed, tema } = useUIStore()
  const location = useLocation()
  useGlobalKeyboardShortcuts()
  useIdleLogout()

  useEffect(() => {
    if (tema === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [tema])

  return (
    <div className="h-full bg-bg-base">
      <Header />
      <EmailDogrulamaBanner />
      <Sidebar />

      {/* Ana içerik alanı */}
      <main
        className={cn(
          'pt-header min-h-full transition-all duration-200 ease-in-out print:pt-0 print:pl-0',
          // tablet (md-lg): her zaman icon-sidebar genişliği (64px)
          'md:pl-sidebar-icon',
          // desktop (lg+): collapsed değilse tam genişlik (256px)
          !sidebarCollapsed && 'lg:pl-sidebar',
        )}
      >
        {isTauri ? (
          <Workspace />
        ) : (
          <div className="p-4 sm:p-5 lg:p-6 min-h-[calc(100vh-56px)]">
            <Outlet key={location.key} />
          </div>
        )}
      </main>

      <NotificationList />
    </div>
  )
}
